import { render, staticRenderFns } from "./RolePurposeTab.vue?vue&type=template&id=1114d397&scoped=true"
import script from "./RolePurposeTab.vue?vue&type=script&lang=js"
export * from "./RolePurposeTab.vue?vue&type=script&lang=js"
import style0 from "./RolePurposeTab.vue?vue&type=style&index=0&id=1114d397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1114d397",
  null
  
)

export default component.exports